// src/b2b/utils/aci.js

/** Parse "(1A,1C,0I)" ou "adt:1,chd:1,inf:0" → {A,C,I} */
export const parseACI = (text = "") => {
  const s = String(text || "");
  // "(1A,1C,0I)"
  let m = /\((\d+)A[ ,]+(\d+)C[ ,]+(\d+)I\)/i.exec(s);

  if (m) return { A: +m[1], C: +m[2], I: +m[3] };
  // "adt:1,chd:1,inf:0"
  m = /adt[:=]\s*(\d+)\s*,\s*chd[:=]\s*(\d+)\s*,\s*inf[:=]\s*(\d+)/i.exec(s);
  if (m) return { A: +m[1], C: +m[2], I: +m[3] };
  
return { A: 0, C: 0, I: 0 };
};

/** Retourne ACI en priorisant allocation → description → value */
export const aciFromItem = (c) => {
  const alloc =
    c?.allocation && (
      Number(c.allocation.adults || 0) +
      Number(c.allocation.children || 0) +
      Number(c.allocation.infants || 0)
    ) > 0
      ? {
          A: Number(c.allocation.adults || 0),
          C: Number(c.allocation.children || 0),
          I: Number(c.allocation.infants || 0),
        }
      : null;

        console.log('%csrc\b2b\aci.js:31 alloc', 'color: #007acc;', alloc);
  if (alloc) return alloc;

  const a = parseACI(c?.desc || c?.description || "");

  if (a.A + a.C + a.I) return a;

  const b = parseACI(c?.value || "");

  if (b.A + b.C + b.I) return b;

  return { A: 0, C: 0, I: 0 };
};

/** Formatte {A,C,I} → "1 adulte et 1 enfant" (fr) */
export const formatACI = ({ A = 0, C = 0, I = 0 } = {}) => {
  const PR = new Intl.PluralRules("fr");
  const W = {
    A: { one: "adulte", other: "adultes" },
    C: { one: "enfant", other: "enfants" },
    I: { one: "bébé",   other: "bébés"   },
  };
  const w = (k, n) => W[k][PR.select(n) === "one" ? "one" : "other"];

  const parts = [];

  if (A) parts.push(`${A} ${w("A", A)}`);
  if (C) parts.push(`${C} ${w("C", C)}`);
  if (I) parts.push(`${I} ${w("I", I)}`);
  
return parts.join(" et ") || "—";
};
